





















import { Vue, Component, Ref } from 'vue-property-decorator'
import { CrmBonusModule } from '@/store/vuex/venda/CrmBonusStore'

@Component({
	components: {
		
	},
})
export default class DialogoDeConfirmarLimiteDoPinCrmBonus extends Vue {
	@Ref() form!: HTMLFormElement

	mostraModalBloqueio = false
	mensagemBloqueio = ""

	abrirModalBloqueio(mensagem: string) {
		this.mensagemBloqueio = mensagem
		this.mostraModalBloqueio = true
	}

	confirmarBloqueio() {
		this.mostraModalBloqueio = false

		CrmBonusModule.resetar()

		CrmBonusModule.setDados({
			bloquearUsoCrmBonus: true,
		})

		this.$emit('confirmarLimite')
	}
}
